// removed by extract-text-webpack-plugin
module.exports = {"InfoRow":"_2HxiM","InfoRowBottom":"_36674"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/FlightDetailsRoundTrip/FlightDetailsRoundTripTuple/FlightDetailsRoundTripTuple.scss
// module id = 709
// module chunks = 0